import argentina from './icons/argentina.svg';
import brazil from './icons/brazil.svg';
import chile from './icons/chile.svg';
import colombia from './icons/colombia.svg';
import mexico from './icons/mexico.svg';
import uruguay from './icons/uruguay.svg';
import usa from './icons/usa.svg';

export const signUpTemplate = {
  firstname: '',
  lastname: '',
  password: '',
  email: '',
  acceptOffers: true,
  profile: {
    profile: 'user.png', base64: '', type: 'image/x-png',
  },
  company: '',
  company_logo: {
    filename: '',
    base64: '',
    type: 'image/x-png',
  },
  currency: 'MXN',
};

const materials = [
  { name: 'MDF' },
  { name: 'Triplay' },
  { name: 'Acrilico' },
  { name: 'Tela' },
  { name: 'Papel picado' },
  { name: 'Vinil' },
  { name: 'Piel' },
  { name: 'Aluminio Anodizado' },
  { name: 'Cartulina' },
  { name: 'Otro' },
];
export default materials;

export const months = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Sept/',
  'Oct.',
  'Nov.',
  'Dic.',
];

/* eslint max-len: ['error', { 'code': 300 }] */
export const popOver = [
  'Es la potencia promedio a lo que trabajará tú máquina para realizar el diseño ingresado.',
  'Es la cantidad de piezas que se obtienen según el tamaño de corte de tu máquina y la medida de la hoja.',
  'En esta sección se elegirá el tipo de tarifa y la categoría que aparece en nuestro recibo de pago de la CFE.',
  'Es el mes en el que deseas realizar el cálculo, es importante recordar que cada mes tiene un costo de tarifa diferente.',
  'Es la región a la cual corresponde tu localidad. Por cada región existe un costo fijo que se aplica a los hogares o pequeños negocios con un elevado consumo eléctrico.',
  'Esta sección va dirigida a tí como vendedor, es decir, se asignara el precio de tu producto.',
  'Es el precio que le asignas a tu diseño para tus clientes.',
  'Es la cantidad de dinero que obtendrías por una sola pieza después de contemplar los costos del material, uso de electricidad y salario del operador.',
  'Es el monto de dinero que obtendrías después de vender todas las piezas según el tamaño del material ingresado anteriormente.',
  'Es la cantidad de piezas que necesitas vender para poder empezar a obtener beneficios, es decir, además de los costos asociados se contempla el precio de la máquina.',
  `En esta sección ingresarás los datos de tu diseños que plasmarás en el material. Para poder realizar el cálculo, es necesario ingresar los datos en la sección de Materia prima.
  <br>Tenga en cuenta que solo se esta calculando el costo del material, sin contemplar gastos de electricidad y operador.`,
  'En esta sección vienen campos complementarios que te ayudarán a realizar un cálculo más preciso de los costos de electricidad.',
  'Es la lectura actual que se muestra en tu medidor.',
  'Es el consumo anterior que tuviste en tu recibo de pago de la CFE.',
  'Es la diferencia entre la lectura actual y el consumo anterior.',
  // Según la selcción de tú región el costo que se te aplica es de:
  // <strong>$ ${store.getState('DACFixedPrice')}</strong>.`,
  'Es la cantidad de dinero que obtendrías por una sola pieza después de contemplar los costos del material, uso de electricidad y salario del operador.',
  'Es el monto de dinero que obtendrías después de vender todas las piezas según el tamaño del material ingresado anteriormente.',
  'En esta sección se ingresan los datos relacionados con tu máquina, es decir, el módelo que usarás para hacer el cálculo.',
  'Es el modelo de la máquina que usarás para el cálculo.',
  'En esta sección se ingresarán los datos relacionados con tu materia prima.',
  'Es el tipo de material a utilizar en la máquina. En caso de que el material no se muestre en la lista, seleccionar la opción Otro',
  'Es el precio al cual adquiriste la hoja de material.',
  'Es la medida (ancho) de la hoja.',
  'Es la medida (largo) de la hoja.',
  'Es el costo calculado según la cantidad de piezas resultantes y el costo total de la hoja. Se hace una proyección',
  'Es la medida (ancho) del diseño.',
  'Es la medida (largo) del diseño.',
  'Es la cantidad de minutos que tardará tu máquina de forma aproximada para plasmar el diseño.',
  'Es la cantidad de diseños que se pueden obtener contemplando el 100% de la hoja a utilizar. Esto se calcula en base a las medidas ingresadas en la sección de Materia prima y el tamaño del diseño.',
  'Es el precio calculado de tu diseño según la medida y el costo de material.',
  'Es el diseño que se plasmará en la máquina CNC, el mismo aparecerá en el resumen de los gastos que usted podrá imprimir posteriormente.',
  'En esta sección se detallarán los costos asociados con el salario del operador. Es importante resaltar que a pesar de que el dueño de la máquina sea el operador tome en cuenta asignarse un salario, esto con la finalidad de que el resultado sea más exacto.',
  'Es el salario mensual que recibe el que se encarga de utilizar la máquina.',
  'Es la cantidad de horas trabajadas por el operador de la máquina.',
  'Es el resultado del pago mensual del operador entre la cantidad de horas que trabaja.',
  'Es el tipo de tarifa que aparece en tu recibo de la CFE.',
  'Es el porcentaje de utilidad que le asignas a tu diseño para tener las ganancias esperadas.',
  'Al ser tarifa DAC (tarifa domestica de alto consumo), implica un costo extra por la CFE. Esto se divide por la cantidad de piezas totales calculadas anteriormente, que nos dará el costo extra para cada pieza.',
  'Este sera el costo de su diseño por pieza, contemplelo para poder agregar un precio de venta a su producto',
  'Es el numero de diseños que se pueden hacer por pieza de tu hoja. Las medidas de 1 pedazo es equivalente al ancho y largo que tiene la maquina seleccionada',
  'redondear el numero de piezas',
  'puedes asignar un costo fijo al consumo electrico de tu equipo por diseño',
  'La tarifa DAC(tarifa domestica de alto consumo) aplica cuando el local/hogar supera un cierto consumo electrico, lo que conlleva a una tarifa mas eleveda. Aplica solo si en tu recibo te marca el tipo de tarifa.',
  'Es el costo por consumo electrico que genera cada diseño.',
  'Seleccione la maquina con la que se calcularan los costos de tus proyectos',
  'Editar',
  'Borrar',
  'Agregar materiales adicionales',
  'Representa el tipo de tubo a utilizar para este equipo, se considera dentro de las calculos el consumo aproximado del tubo',
];

export const dacRegions = {
  tarifas: [
    {
      id_tarifa: 'Noroeste',
      tipo: 'DAC',
      estados: 'Sonora, Sinaloa',
      cargos: [
        'recvFcdd6Rp0k41ru',
      ],
      dacPrice: 6.076,
      fixedCost: 130.01,
      uso_dac: 1,
    },
    {
      id_tarifa: 'Baja California Verano',
      tipo: 'DAC',
      estados: 'Baja California Verano',
      cargos: [
        'recb4MSvXVeoTR8gj',
      ],
      dacPrice: 6.305,
      fixedCost: 130.01,
      uso_dac: 1,
    },
    {
      id_tarifa: 'Baja California Sur Verano',
      tipo: 'DAC',
      estados: 'Baja California Sur Verano',
      cargos: [
        'rectoTrBuiv6xyaR8',
      ],
      dacPrice: 6.868,
      fixedCost: 130.01,
      uso_dac: 1,
    },
    {
      id_tarifa: 'Sur y Peninsular',
      tipo: 'DAC',
      estados: 'Nayarit, Jalisco, Colima, Michoacán, Aguascalientes, Guanajuato, Querétaro, Hidalgo, Guerrero, Tlaxcala, Puebla, Oaxaca, Chiapas, Tabasco, Zacatecas Sur, San Luís Potosí Sur, Veracruz Sur, Morelos, Yucatán, Campeche, Quintana Roo',
      cargos: [
        'recbJco5OpUzgVNf1',
      ],
      dacPrice: 6.013,
      fixedCost: 130.01,
      uso_dac: 1,
    },
    {
      id_tarifa: 'Baja California Fuera de Verano',
      tipo: 'DAC',
      estados: 'Baja California Fuera de Verano',
      cargos: [
        'recxclb4TVZhnS9N7',
      ],
      dacPrice: 5.417,
      fixedCost: 130.01,
      uso_dac: 1,
    },
    {
      id_tarifa: 'Central',
      tipo: 'DAC',
      estados: 'Distrito Federal, Estado de México',
      cargos: [
        'rec37RAa2hLme9sZX',
      ],
      dacPrice: 6.486,
      fixedCost: 130.01,
      uso_dac: 1,
    },
    {
      id_tarifa: 'Baja California Sur Fuera de Verano',
      tipo: 'DAC',
      estados: 'Baja California Sur Fuera de Verano',
      cargos: [
        'recv1rHPvNGAVqrKH',
      ],
      dacPrice: 6.076,
      fixedCost: 130.01,
      uso_dac: 1,
    },
    {
      id_tarifa: 'Norte y Noreste',
      tipo: 'DAC',
      estados: 'Chihuahua, Durango, Zacatecas Norte, Coahuila, Nuevo León, Tamaulipas, San Luís Potosí Norte, Veracruz Norte',
      cargos: [
        'recHhMGg8QigMncQi',
      ],
      dacPrice: 6.076,
      fixedCost: 130.01,
      uso_dac: 1,
    },
  ],
};

export const states = [
  'Aguascalientes',
  'Baja California Sur Verano',
  'Baja California Sur Fuera de Verano',
  'Baja California Verano',
  'Baja California Fuera de Verano',
  'Campeche',
  'Chiapas',
  'Chihuahua',
  'Coahuila',
  'Colima',
  'Distrito Federal',
  'Durango',
  'Estado de México',
  'Guanajuato',
  'Querétaro',
  'Guerrero',
  'Hidalgo',
  'Jalisco',
  'Michoacán',
  'Morelos',
  'Nayarit',
  'Nuevo León',
  'Oaxaca',
  'Puebla',
  'Quintana Roo',
  'San Luís Potosí Norte',
  'San Luís Potosí Sur',
  'Sonora',
  'Sinaloa',
  'Tamaulipas',
  'Tlaxcala',
  'Veracruz Norte',
  'Veracruz Sur',
  'Tabasco',
  'Yucatán',
  'Zacatecas Norte',
  'Zacatecas Sur',
];

/* eslint object-curly-newline: ["off", "always"] */
export const currencies = [
  { currency: 'Mexican Peso', currencyCode: 'MXN', country: 'Mexico', symbol: '$', image: mexico },
  { currency: 'American Dollar', currencyCode: 'USD', country: 'USA', symbol: '$', image: usa },
  { currency: 'Chilean Peso', currencyCode: 'CLP', country: 'Chile', symbol: '$', image: chile },
  { currency: 'Argentine Peso', currencyCode: 'ARS', country: 'Argentina', symbol: '$', image: argentina },
  { currency: 'Uruguayan Peso', currencyCode: 'UYU', country: 'Uruguay', symbol: '$U', image: uruguay },
  { currency: 'Colombian Peso', currencyCode: 'COP', country: 'Colombia', symbol: '$', image: colombia },
  { currency: 'Brazilian Real', currencyCode: 'BRL', country: 'Brazil', symbol: 'R$', image: brazil },
];

export const laserPipe = [
  { id: '1295 - CNC 4040 - 3 Axis - M2 - 50w', pipes: [{ pipeName: 'Pyro Laser 50w', durability: 2500, price: 3290, costPerHour: 1.316 }] },
  { id: '1459 - CNC 3020 - 2 Axis - Antiflama - 40w', pipes: [{ pipeName: 'Pyro Laser 40w', durability: 2500, price: 2990, costPerHour: 1.196 }] },
  { id: '1032 - CNC 3020 - 2 Axis - 40w', pipes: [{ pipeName: 'Pyro Laser 40w', durability: 2500, price: 2990, costPerHour: 1.196 }] },
  { id: '1045 - CNC 4040 - 2 Axis - 50w', pipes: [{ pipeName: 'Pyro Laser 50w', durability: 2500, price: 3290, costPerHour: 1.316 }] },
  { id: '1301 - CNC 250130 - 3 Axis - 150w', pipes: [{ pipeName: 'EFR Laser F6 150w', durability: 6000, price: 18490, costPerHour: 3.082 }, { pipeName: 'Weson 300w', durability: 10000, price: 85990, costPerHour: 8.599 }] },
  { id: '1458 - CNC 9060 - 3 Axis - 100w', pipes: [{ pipeName: 'EFR Laser F2 95w', durability: 6000, price: 7390, costPerHour: 1.232 }, { pipeName: 'Reci Laser T2 100w', durability: 8000, price: 7990, costPerHour: 0.999 }] },
  { id: '1568 - CNC 4040 - 3 Axis - Ruida - 50w', pipes: [{ pipeName: 'Pyro Laser 50w', durability: 2500, price: 3290, costPerHour: 1.316 }] },
  { id: '1355 - CNC 6040 - 3 Axis - Ruida - 80w', pipes: [{ pipeName: 'EFR Laser F2 95w', durability: 6000, price: 7390, costPerHour: 1.232 }] },
  { id: '1580 - CNC 6040 - 3 Axis - Ruida - 50w', pipes: [{ pipeName: 'Pyro Laser 50w', durability: 2500, price: 3290, costPerHour: 1.316 }] },
  { id: '1311 - CNC 6040 - 3 Axis - M2 - 50w', pipes: [{ pipeName: 'Pyro Laser 50w', durability: 2500, price: 3290, costPerHour: 1.316 }] },
];
